<template>
  <div>
        <el-tabs type="border-card">

            <el-tab-pane label="已购买资源">
                 <div>
                    <el-button size='mini' type="info" plain  @click="onDetail()">查看</el-button>
<!--                    <el-button size='mini' type="info" plain @click="onLineEdit()">在线编辑</el-button>-->
                    <el-button size='mini' type="info" plain @click="Download()">下载</el-button>
                   <el-form :inline="true" :model="dataForm" class="demo-form-inline" size="mini" ref="dataForm">
                     <el-form-item prop="input" >
                       <el-input v-model="dataForm.input"  placeholder="请输入资源名称"></el-input>
                     </el-form-item>
                     <el-form-item>
                       <el-button type="primary" @click="search('dataForm')" >查询</el-button>
                     </el-form-item>
                     <el-form-item>
                       <el-button @click="resetForm('dataForm')" type="primary" plain>重置</el-button>
                     </el-form-item>
                   </el-form>
                </div>
                <div>
                  <el-table ref="multipleTable" :data="tableDatas"  tooltip-effect="dark" border highlight-current-row
                            @selection-change="handleSelectionChange">
                    <el-table-column align="center" type="selection"></el-table-column>
                    <!--                        <el-table-column align="center" type=index label="序号"></el-table-column>-->
                    <el-table-column align="center" prop="VProductName" show-overflow-tooltip label="资源名称" width="180px"></el-table-column>
                    <!-- <el-table-column align="center" prop="antistop" label="关键词"></el-table-column> -->
                    <el-table-column align="center" prop="VProductDesc" show-overflow-tooltip label="内容简介"></el-table-column>
                    <el-table-column align="center" prop="IProductType" :formatter="resourceFormatter" label="资源类型" width="70px"></el-table-column>
                    <el-table-column align="center" prop="VProductTypeName" label="学科分类" width="100px"></el-table-column>
                    <!-- <el-table-column align="center" prop="knowledgehierarchy" label="知识体系分类"></el-table-column> -->
                    <el-table-column align="center" prop="VWriterName" label="作者信息" width="60px"></el-table-column>
                    <!-- <el-table-column align="center" prop="organization" label="作者所属机构"></el-table-column>  -->
                    <el-table-column align="center" prop="IPrice" label="价格" width="80px"></el-table-column>
                    <!--                        <el-table-column align="center" prop="IsEdit" :formatter="isEditFormatter" label="是否可编辑"></el-table-column>-->
                    <!-- <el-table-column align="center" prop="Browsenumber" label="浏览次数"></el-table-column> -->
                  </el-table>
                  <!-- 分页 -->
                  <el-pagination
                    background
                    @current-change="handleCurrentChange"
                    :page-sizes="[10]"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total='total'
                    class="sorter">
                  </el-pagination>
                </div>


                <!-- 富文本编辑 -->
                <el-dialog
                    title="编辑"
                    :visible.sync="dialogVisible2"
                    width="50%">
                    <div id="websiteEditorElem2">
                        <div ref="editorElem"></div>
                    </div>
                    <div slot="footer" class="dialog-footer">
                        <el-button @click="dialogFormVisible = false">取 消</el-button>
                        <el-button type="primary" @click="submit()">确 定</el-button>
                    </div>
                </el-dialog>


              <!-- 富文本编辑 -->
              <el-dialog
                title="查看"
                :visible.sync="dialogVisibleDetail"
                width="40%" >
                <div class="detail">
                  <div class="info">资源名称:{{info.VProductName}}</div>
                  <div class="info">内容简介:{{info.VProductDesc}}</div>
                  <div class="info">学科分类:{{info.VProductTypeName}}</div>
                  <div class="info">作者:{{info.VWriterName}}</div>
                  <div class="info">价格:{{info.IPrice}}</div>
                </div>
                <div slot="footer" class="dialog-footer">
                  <el-button @click="dialogVisibleDetail = false">取 消</el-button>
                </div>
              </el-dialog>
            </el-tab-pane>
            <!-- <el-tab-pane label="下载资源"></el-tab-pane> -->
        </el-tabs>
        <a id="linkUrl" href=""></a>
  </div>
</template>

<script>
import E from 'wangeditor'
import { getUser } from './../../../../untils/auth'
export default {
    name:'purchasedResource',
    data() {
        return {
            dataForm:{
              input:''
            },
            currentRow: '',
            dialogVisible: false,
            dialogVisible2: false,
            dialogFormVisible: true,

            dialogVisibleDetail:false,
            dialogDetailVisible: true,
            tableDatas:[],
            multipleSelection:[],
            total: 0,
            size: 6,
            currentPage: 0,
          info: {}
        }
    },
    created() {
        this.onDownloadRes(0);
    },
    methods: {
      // 下一页
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.onDownloadRes(val);
      },
      handleCurrentChange(val) {
        this.onDownloadRes(val);
      },

        resetForm(e) {
            this.$refs.dataForm.resetFields()
          this.onDownloadRes(0);
        },
        search(){
          if(this.dataForm.input){
            let userId = JSON.parse(getUser()) ? JSON.parse(getUser()).principal.VUserId : '';
            this.axios.post(window.IPConfig.IP + '/tBPrivateorder/queryPageAll.do',
              {
                "VSystemId": this.$store.state.user.VSystemId,
                "VUserId": userId,
                "current": 0,
                "size": this.size,
                "VProductName": this.dataForm.input,
              }
            ).then((response) => {
              console.log(response)
              if (response.status == 200) {
                if (response.data.obj){
                  this.tableDatas = response.data.obj;
                  this.total = response.data.total;
                }else{
                  this.tableDatas = [];
                  this.total = 0;
                }
              }
            });
          }else{
            this.$message('请输入要查询的内容');
          }
        },
        handleSelectionChange(val) {
            // this.multipleSelection = val;
            if (val.length>1){
                this.$refs.multipleTable.clearSelection();
                this.$refs.multipleTable.toggleRowSelection(val.pop());
            }
            this.multipleSelection = val
        },
        // 资源转换
        resourceFormatter(row, column) {
            if(row.IProductType == 3){
                row.IProductType = '课件'
            }else if(row.IProductType == 4){
                row.IProductType = '文档'
            }
            return row.IProductType;
        },
        // 是否可编辑
     /*   isEditFormatter(row, column) {
            if(row.IsEdit == 0){
                row.IsEdit = '不可编辑';
            }else if(row.IsEdit == 4){
                row.IsEdit = '可编辑';
            }
            return row.IsEdit;
        },*/
        // 列表请求(已购买的资源)
        onDownloadRes (current){
            let userId = JSON.parse(getUser()) ? JSON.parse(getUser()).principal.VUserId : '';
            console.log(userId)
            this.axios.post(window.IPConfig.IP + '/tBPrivateorder/queryPageAll.do',
                {
                    "VSystemId": this.$store.state.user.VSystemId,
                    "VUserId": userId,
                    "current": current,
                    "size": this.size
                }
            ).then((response) => {
              console.log(response)
                if (response.status == 200) {
                  if (response.data.obj){
                    this.tableDatas = response.data.obj;
                    this.total = response.data.total;
                  }else{
                    this.tableDatas = [];
                    this.total = 0;
                  }
                }
            });
        },
        // handleCurrentChange(val) {
        //     this.currentRow = val;
        // },
      // 在线编辑
      onDetail (){
        // 获取被选择的行内容
        let editContent = this.multipleSelection[0];
        // let editContent = this.currentRow;
        if(editContent){
          // if(editContent.IsEdit == 0){
          this.dialogVisibleDetail = true;
          this.info = editContent
        }else{
          this.$message.error('请选择需要编辑的行数据');
        }
      },
        // 在线编辑
        onLineEdit (){
            // 获取被选择的行内容
            let editContent = this.multipleSelection[0];
            // let editContent = this.currentRow;
            if(editContent){
                if(editContent.IsEdit == '不可编辑'){
                    this.dialogVisible2 = true;
                    var self = this;
                    setTimeout(() => {
                        self.createEditor(editContent)
                    })
                }else{
                    this.$message.error('当前资源不可编辑')
                }
            }else{
                this.$message.error('请选择需要编辑的行数据');
            }
        },
        createEditor (editContent) {
            if (!this.phoneEditor) {
                var self = this
                this.phoneEditor = new E(this.$refs.editorElem);
                this.phoneEditor.customConfig.onchange = function (html) {
                    self.VAuditSuggest = html
                }
                // 上传图片到服务器，base64形式
                var url = window.IPConfig.IP + '/vueUploadImg.do'
                this.phoneEditor.customConfig.uploadFileName = 'file';
                this.phoneEditor.customConfig.uploadImgServer = url
                this.phoneEditor.customConfig.debug = true
                // 隐藏网络图片
                this.phoneEditor.customConfig.showLinkImg = false
                // 创建一个富文本编辑器
                this.phoneEditor.create()
                // 富文本内容
                this.phoneEditor.txt.html(editContent.VProductDesc);
            }
        },
        // 编辑完成
        submit() {
            this.axios.post(window.IPConfig.IP + '/tBusProOrder/add.do',
                {
                    VAuditSuggest: this.VAuditSuggest,
                    VProductId: this.VProductId,
                    createdBy: JSON.parse(getUser()).principal.VUserId
                }
            ).then(res => {
                if (res.status == 200) {
                    this.$message({
                        msg: res.msg,
                        type: 'success'
                    })
                    var self = this
                    setTimeout(() => {
                        self.phoneEditor.txt.clear()
                        self.VProductId = ''
                        self.dialogVisible = false
                        self.dialogVisible2 = false
                    },600)
                }
            })
        },
        // 下载
        Download() {
            if (getUser()) {
                if(this.multipleSelection){
                    window.open(window.IPConfig.IP + '/files/download?id=' + this.multipleSelection[0].VProductId)
                    // let link = document.getElementById('linkUrl')
                    // // this.axios.get(window.IPConfig.IP + '/files/download?id=' + this.$route.query.VProductId).then(res => {
                    // // })
                    // link.href = window.IPConfig.IP + '/files/download?id=' + this.currentRow.VProductId
                    // link.click();
                }else{
                    this.$message.error('请选择要下载的数据')
                }
            } else {
                this.jump('/login')
            }
        },
    }
}
</script>

<style lang="stylus" scoped>
  .demo-form-inline {
      float right
  }
  .sorter {
  text-align center
  margin-top .1rem
  }
  .el-table .cell.el-tooltip {
    white-space: nowrap;
    min-width: 50px;
  }

  .el-table .cell {
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: normal;
    word-break: break-all;
    line-height: 23px;
    padding-right: 10px;
  }

    .detail .info{
      line-height:0.25rem;
      margin:0 15px
    }
</style>



// WEBPACK FOOTER //
// src/components/Personalcenter/components/my/purchasedResource.vue